import React, { useCallback, useMemo } from 'react'
import { CheckingRuleResult } from '@/enums/checkingRuleResult'
import { usePermissionChecker } from '@/hooks/usePermissionChecker'
import { useLocalization } from '@/hooks/localization'
import { Button } from '@/components/button'
import { getStore } from '@/store'
import { push } from 'react-router-redux'
import { ReportSubmissionGroupState } from '@/enums/ReportSubmissionGroupState'
import { ReportGroupProcessState } from '@/enums/reportGroupProcessState'

function SubmitButton ({ submissionGroup, processState }) {
  const isGranted = usePermissionChecker()
  const { localize } = useLocalization()

  const { id, forecasting, highestSeverity, cellsContainErrors, state } = (submissionGroup || {})

  const isGrantedToSubmit = useMemo(() =>
    isGranted(forecasting ? 'CanSubmitForecast' : 'CanSubmitReports'), [forecasting, isGranted])

  const hideSubmitButton = useMemo(() =>
    state === ReportSubmissionGroupState.enum.Sent ||
    state === ReportSubmissionGroupState.enum.Accepted, [state])

  const isDisabled = useMemo(() => processState > 0 && processState !== ReportGroupProcessState.enum.Signing,
    [processState])

  const buttonColor = useMemo(() => {
    if (highestSeverity === CheckingRuleResult.enum.Error || cellsContainErrors) {
      return 'danger'
    } else if (highestSeverity === CheckingRuleResult.enum.Warning) {
      return 'warning'
    }
    return 'primary'
  }, [cellsContainErrors, highestSeverity])

  const signUrl = useMemo(() => forecasting
    ? `/forecast-report-submission-groups/${id}/report-submissions/submit-report`
    : `/report-submission-groups/${id}/report-submissions/submit-report`, [forecasting, id])

  const onClick = useCallback(() => getStore().dispatch(push(signUrl)), [signUrl])

  return !hideSubmitButton && submissionGroup && isGrantedToSubmit ? <Button disabled={isDisabled}
    color={buttonColor}
    onClick={onClick}
    icon={highestSeverity === CheckingRuleResult.enum.Error || highestSeverity === CheckingRuleResult.enum.Warning ? 'error' : 'bx-send'}
    title={highestSeverity === CheckingRuleResult.enum.Error ? localize('Reporting.CheckingRulesError') : ''}>
    {localize('Common:Submit')}
  </Button> : null
}

export default SubmitButton



// WEBPACK FOOTER //
// ./src/report-app/pages/reporting/submissions/reportSubmissionsSubmitButton.js